import React, { useEffect } from 'react';
import { View, Text, Animated, StyleSheet } from 'react-native';

export const Toast = ({ message, type = 'success', onHide }) => {
  const translateY = new Animated.Value(-100);

  useEffect(() => {
    // Slide in
    Animated.spring(translateY, {
      toValue: 0,
      useNativeDriver: true,
      tension: 80,
      friction: 10
    }).start();

    // Slide out after 3 seconds
    const timer = setTimeout(() => {
      Animated.timing(translateY, {
        toValue: -100,
        duration: 300,
        useNativeDriver: true
      }).start(() => {
        if (onHide) onHide();
      });
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return '#4caf50';
      case 'error':
        return '#f44336';
      case 'warning':
        return '#ff9800';
      default:
        return '#4caf50';
    }
  };

  return (
    <Animated.View style={[
      styles.container,
      { transform: [{ translateY }], backgroundColor: getBackgroundColor() }
    ]}>
      <Text style={styles.text}>{message}</Text>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 20,
    left: '50%',
    transform: [{ translateX: -150 }],
    width: 300,
    padding: 16,
    borderRadius: 8,
    zIndex: 9999,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  text: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    fontFamily: 'VastagoGrotesk',
  }
}); 